interface LogoFullProps {
  className?: string;
  variant?: 'dark' | 'light';
  glow?: boolean;
}

export default function LogoFull({ className = '', variant = 'dark', glow = false }: LogoFullProps) {
  const accentColor = '#D95E16';
  const bodyColor = variant === 'light' ? '#FFFFFF' : '#2C2C2C';

  return (
    <svg
      viewBox="125 300 560 195"
      className={className}
      style={glow ? { filter: 'drop-shadow(0 0 4px rgba(255,255,255,0.85)) drop-shadow(0 0 8px rgba(255,255,255,0.5))' } : undefined}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* G Icon - orange arc */}
      <path
        fill={accentColor}
        d="M372.58,343.57c8.25-4.5,17.69-6.83,27.42-6.48,10.35,0,19.72,4.2,26.5,10.97l17.67-17.66c-11.31-11.31-26.92-18.29-44.16-18.29-50.88,0-79.63,57.32-51.34,98.06-10.02-24.96.25-53.66,23.91-66.59"
      />
      {/* G Icon - body */}
      <path
        fill={bodyColor}
        d="M461.21,362.07h-48.72l-24.99,24.99h47.84c-5.14,14.55-19.02,24.98-35.34,24.98-10.35,0-19.72-4.19-26.5-10.97-12.47-12.47-14.52-32.25-4.89-46.98-17.94,14.61-22.42,40.29-10.68,60.08,9.26,15.6,24.47,22.86,42.07,22.86,34.64,0,62.46-28.11,62.46-62.47,0-4.28-.43-8.46-1.25-12.49"
      />

      {/* GENERATIVE text */}
      <g fill={bodyColor}>
        {/* G */}
        <path d="M157.47,487.18h-18.89c-7.81,0-14.17-6.36-14.17-14.17s6.36-14.17,14.17-14.17h18.96v4.36h-18.96c-5.41,0-9.81,4.4-9.81,9.81s4.4,9.81,9.81,9.81h14.53v-7.12h-10.33v-4.36h14.68v15.84Z" />
        {/* E */}
        <rect x="168.47" y="458.84" width="28.19" height="4.36" />
        <polygon points="196.66 470.53 196.66 474.88 172.83 474.88 172.83 482.83 196.66 482.83 196.66 487.18 168.47 487.18 168.47 470.53" />
        {/* N */}
        <rect x="206.74" y="458.84" width="4.36" height="28.19" />
        <rect x="232.88" y="458.84" width="4.36" height="28.19" />
        <polygon points="212.27 458.84 209.16 458.84 207.64 460.25 232.48 487 235.67 484.04 212.27 458.84" />
        {/* E */}
        <rect x="248.08" y="458.84" width="28.19" height="4.36" />
        <polygon points="276.27 470.53 276.27 474.88 252.44 474.88 252.44 482.83 276.27 482.83 276.27 487.18 248.08 487.18 248.08 470.53" />
        {/* R */}
        <path d="M291.58,487.18h-4.36v-15.79h22.63c2.28,0,4.13-1.85,4.13-4.13s-1.85-4.13-4.13-4.13h-21.99v-4.36h21.99c4.68,0,8.48,3.81,8.48,8.48s-3.8,8.48-8.48,8.48h-18.27v11.43Z" />
        <polygon points="320.02 487.13 306.31 471.5 303.04 474.38 314.23 487.13 320.02 487.13" />
        {/* A */}
        <polygon points="348.52 464.78 361.23 487.18 366.24 487.18 350.11 458.74 346.94 458.74 330.81 487.18 335.82 487.18 348.52 464.78" />
        {/* T */}
        <rect x="368.5" y="458.79" width="30.49" height="4.36" />
        <rect x="381.26" y="460.05" width="4.36" height="27.06" />
        {/* I */}
        <rect x="408.56" y="458.84" width="4.36" height="28.34" />
        {/* V */}
        <polygon points="440.6 481.14 453.3 458.74 458.31 458.74 442.18 487.18 439.01 487.18 422.88 458.74 427.89 458.74 440.6 481.14" />
        {/* E */}
        <rect x="468.31" y="458.84" width="28.19" height="4.36" />
        <polygon points="496.5 470.53 496.5 474.88 472.67 474.88 472.67 482.83 496.5 482.83 496.5 487.18 468.31 487.18 468.31 470.53" />
      </g>

      {/* A inner triangle (orange accent) */}
      <polygon
        fill={accentColor}
        points="343.9 487.18 352.99 487.18 348.44 479.18 343.9 487.18"
      />

      {/* TECH text */}
      <g fill={accentColor}>
        {/* T */}
        <rect x="534.65" y="458.79" width="30.49" height="4.36" />
        <rect x="547.41" y="460.05" width="4.36" height="27.06" />
        {/* E */}
        <rect x="572.53" y="458.84" width="28.19" height="4.36" />
        <polygon points="600.72 470.53 600.72 474.88 576.89 474.88 576.89 482.83 600.72 482.83 600.72 487.18 572.53 487.18 572.53 470.53" />
        {/* C */}
        <path d="M637.32,487.18h-16.3c-7.81,0-14.17-6.36-14.17-14.17s6.36-14.17,14.17-14.17h16.3v4.36h-16.3c-5.41,0-9.81,4.4-9.81,9.81s4.4,9.81,9.81,9.81h16.3v4.36Z" />
        {/* H */}
        <rect x="646.22" y="458.84" width="4.36" height="28.34" />
        <rect x="671.23" y="458.84" width="4.36" height="28.34" />
        <rect x="646.68" y="470.41" width="27.03" height="4.36" />
      </g>
    </svg>
  );
}